import React from 'react'
import { Tile } from 'carbon-components-react'

const ClientSummary = (pageData) => {

  return (
    <>
      <Tile light="true" className="row d-flex flex-w">
        <h5 className="tile-title">Dashboard</h5>
        <div className="col-md-6 col-lg-3 m-005">
          <Tile className="text-center bg-warning-lt">
            <div>Unanswered Tickets</div>
            <div className="mt-05">0</div>
          </Tile>
        </div>
        <div className="col-md-6 col-lg-3 m-005">
          <Tile className="text-center bg-info-lt">
            <div>In Progress Projects</div>
            <div className="mt-05">0</div>
          </Tile>
        </div>
        <div className="col-md-6 col-lg-3 m-005">
          <Tile className="text-center bg-danger-lt">
            <div>Unpaid Invoices</div>
            <div className="mt-05">0</div>
          </Tile>
        </div>
        <div className="col-md-6 col-lg-3 m-005">
          <Tile className="text-center bg-success-lt">
            <div>Paid Invoices</div>
            <div className="mt-05">0</div>
          </Tile>
        </div>
      </Tile>
    </>
  )
}

export default ClientSummary